.hidden {
  display: none;
}

.noError {
  padding: calc(var(--dds-spacing-small-4) + 2px);
}

.hasError {
  padding: var(--dds-spacing-small-4);
  border: 2px solid var(--dds-color-dark-red);
}

.errorMessage {
  color: var(--dds-color-dark-red);
}
